import { L } from '@lib';
import { Rules } from '@utils';
import { Col, Form, FormInstance, Input, Row } from 'antd';
import React from 'react';
import { SharedForm } from '../SharedForm';
import { PostcodeSelect } from '@components';

interface IProps {
  editMode?: boolean;
  form: FormInstance<any>;
  initialValues?: any;
  onFinish: (values: any) => Promise<void>;
  onCancel: (value: boolean) => void;
  handleAddressSearch: (text: string) => void;
}

export const CustomerForm: React.FC<IProps> = (props) => {
  const { form, initialValues, handleAddressSearch } = props;
  return (
    <SharedForm
      {...props}
      name="createOrUpdateCustomer"
      layout="vertical"
      submitTitle={(!props.editMode && L('Confirm customer')) || L('Save changes')}
    >
      <Form.Item name="id" hidden>
        <Input type="text" />
      </Form.Item>
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="name" label={L('Name')} rules={Rules.required}>
            <Input placeholder={L('Enter name')} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="surname" label={L('Surname')} rules={Rules.required}>
            <Input placeholder={L('Enter surname')} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item
            name="email"
            label={
              <span>
                {L('Email')}{' '}
                <span style={{ fontWeight: 'normal', fontSize: 12, color: 'rgba(0, 0, 0, 0.45)' }}>
                  {L("— Without an Email an App customer won't connect to this listing")}
                </span>
              </span>
            }
            rules={Rules.emailNotRequired as any}
          >
            <Input disabled={initialValues?.userId} placeholder={L('Enter your email')} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="postcode" label={L('Postcode')}>
            <PostcodeSelect value={form.getFieldValue('postcode')} onSelect={handleAddressSearch} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="phone" label={L('Mobile')} rules={Rules.phone}>
            <Input placeholder={L('Enter mobile phone')} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="landline" label={L('Landline - [If no mobile, duplicate landine into mobile field]')}>
            <Input placeholder={L('Enter landline number')} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="city" label={L('City')}>
            <Input placeholder={L('Enter your city')} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="country" label={L('Country')}>
            <Input placeholder={L('Enter your country')} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item name="businessName" label={L('Business name')}>
            <Input placeholder={L('Enter your business name')} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item name="address" label={L('Address')}>
            <Input placeholder={L('Enter your address')} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item name="secondAddress" label={L('Address')}>
            <Input placeholder={L('Enter your address')} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item name="thirdAddress" label={L('Address')}>
            <Input placeholder={L('Enter your address')} />
          </Form.Item>
        </Col>
      </Row>
    </SharedForm>
  );
};